<div class="right-panel-block">
  <div class="members panel-row">
    <div class="panel-title">
      MEMBERS:
    </div>
    <div class="panel-content">
      <app-project-members></app-project-members>
    </div>
  </div>

  <div class="panel-buttons panel-row">
    <div class="panel-title">
      DROPBOX:
    </div>
    <div class="panel-content">
      <div class="panel-button link">
        <button mat-button class="panel-mat-button open-dropbox-button" (click)="openDropbox()"
                [disabled]="!dropBoxLink" [ngClass]="{'disabled-button': !dropBoxLink}">
          <div *ngIf="!dropBoxLoading">Open Dropbox</div>
          <lib-mini-progress-spinner *ngIf="dropBoxLoading"></lib-mini-progress-spinner>

        </button>
      </div>

      <div class="panel-button link">
        <button mat-button class="panel-mat-button open-dropbox-button" (click)="syncDropBox()"
                [disabled]="!dropBoxLink" [ngClass]="{'disabled-button': !dropBoxLink}">
          <div *ngIf="!dropBoxSyncLoading">Sync Dropbox</div>
          <lib-mini-progress-spinner *ngIf="dropBoxSyncLoading"></lib-mini-progress-spinner>

        </button>
      </div>

      <div class="panel-button link" *ngIf="currentUser.adminNSales || currentUser.engineerNSales || currentUser.materialManagerRole">
        <button mat-button class="panel-mat-button change-dropbox-button" (click)="changeDropboxPath()">
          Change Path
        </button>
      </div>

    </div>
  </div>

  <div class="panel-buttons panel-row">
    <div class="panel-title">
      QB:
    </div>
    <div class="panel-content">
      <div class="panel-button link">
        <button mat-button class="panel-mat-button open-qb-button" (click)="openEstimates()"
                [disabled]="!project.customer?.id" [ngClass]="{'disabled-button': !project.customer?.id}">
          <div>Billing</div>
        </button>
      </div>

    </div>
  </div>

  <div class="panel-buttons panel-row">
    <div class="panel-title">
      Docusign:
    </div>
    <div class="panel-content">
      <!-- <div class="panel-button link">
        <button mat-button class="panel-mat-button open-qb-button" (click)="openQB()"
          [disabled]="!project.customer?.id" [ngClass]="{'disabled-button': !project.customer?.id}">
          <div>Open QB</div>

        </button>
      </div> -->
      <div class="panel-button link">
        <button mat-button class="panel-mat-button open-qb-button" (click)="openDocu()">
          <div>Create Envelope</div>
        </button>
      </div>
      <div class="panel-button link">
        <button mat-button class="panel-mat-button open-qb-button" (click)="openEnvelopes()">
          <div>Envelopes</div>
        </button>
      </div>


    </div>
  </div>

  <div class="panel-buttons panel-row">
    <div class="panel-title">
      Cabinets:
    </div>
    <div class="panel-content">
      <div class="panel-button link">
        <button class="panel-mat-button" mat-button (click)="openCabinetsToggleStatusDialog('finishingSubmit')"
                [disabled]="!(project.type.name === 'OrderFinishing' || project.type.name === 'InHouseFinishing')"
                [ngClass]="{'disabled-button': !(project.type.name === 'OrderFinishing' || project.type.name === 'InHouseFinishing')}">
          Fin. Submit
        </button>
      </div>
      <div class="panel-button link">
        <button class="panel-mat-button" mat-button (click)="openCabinetsToggleStatusDialog('assembly')">
          Assembly
        </button>
      </div>
      <div class="panel-button link">
        <button class="panel-mat-button" mat-button (click)="openCabinetsToggleStatusDialog('qualityControl')">
          Q. Control
        </button>
      </div>
      <div class="panel-button link">
        <button class="panel-mat-button" mat-button (click)="openCabinetsToggleStatusDialog('jobDelivery')">
          Delivery
        </button>
      </div>

    </div>
  </div>

    <div class="panel-buttons panel-row">
        <div class="panel-title">
            Materials:
        </div>
        <div class="panel-content">
            <div class="panel-button link">
                <button mat-button class="panel-mat-button open-qb-button" (click)="openMaterialsReport()">
                    <div>Materials Report</div>
                </button>
            </div>

        </div>
    </div>

  <div class="panel-buttons panel-row" *ngIf="systemState === 'California'">
    <div class="panel-buttons panel-row">
      <div class="panel-title">
        PRODUCTION:
      </div>
      <div class="panel-content">
        <div class="panel-button print">
          <button class="panel-mat-button labels-print-button" mat-button (click)="sendToProd()"
                  [disabled]="!!project.migratedDate" [ngClass]="{'disabled-button': !!project.migratedDate}">
            <ng-container *ngIf="!project.migratedDate">
              Send to PROD
            </ng-container>
            <ng-container *ngIf="project.migratedDate">
              Sent to PROD

              <i class="pi pi-info-circle sent-to-prod-info-icon"
                 pTooltip="Sent By: {{project.migratedBy?.name}}
			{{project.migratedDate | date: 'MMM dd h:mm a'}}"
                 tooltipStyleClass="sent-to-prod-info-panel"
                 tooltipPosition="bottom"></i>
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-buttons panel-row">
    <div class="panel-title">
      ACTIONS:
    </div>
    <div class="panel-content">
      <div class="panel-button print" *ngIf="currentUser.adminRole || currentUser.engineerNSales">
        <button class="panel-mat-button labels-print-button" mat-button (click)="openProjectPricing()">Open Pricing
        </button>
      </div>

      <div class="panel-button print">
        <button class="panel-mat-button labels-print-button" mat-button (click)="openPdfLabels()">Shipping
          Label
        </button>
      </div>

      <div class="panel-button print">
        <button mat-button class="panel-mat-button labels-print-button" (click)="printLabels()"
                [ngClass]="{'scanning': scanLoading, 'disabled-button': !project.hasCvFile}"
                [disabled]="!project.hasCvFile">
          <div class="scan-wrapper-block">
            <div *ngIf="!scanLoading">Print Labels</div>
            <lib-mini-progress-spinner *ngIf="scanLoading"></lib-mini-progress-spinner>
          </div>
        </button>
      </div>

      <div class="panel-button" *ngIf="currentUser.adminRole || currentUser.engineerNSales">
        <button mat-button class="panel-mat-button" (click)="openCopyProjectDialog()">
          Copy Project
        </button>
      </div>

      <div class="panel-button delete" *ngIf="currentUser.adminRole || currentUser.engineerNSales || currentUser.materialManagerRole">
        <button mat-button class="panel-mat-button delete-item-button" (click)="disableCVSync()">
          Delete CV Sync
        </button>
      </div>

      <div class="panel-button delete">
        <button mat-button class="panel-mat-button delete-item-button" (click)="deleteProject()">

          <div *ngIf="!projectDeleteLoading">Delete Project</div>
          <lib-mini-progress-spinner *ngIf="projectDeleteLoading"></lib-mini-progress-spinner>
        </button>
      </div>

      <p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="project-panel">
      </p-confirmDialog>
    </div>
  </div>
</div>
